import { render, staticRenderFns } from "./AboutHomeThree.vue?vue&type=template&id=04f16fde&"
import script from "./AboutHomeThree.vue?vue&type=script&lang=js&"
export * from "./AboutHomeThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports